import React from "react";
import "./LegalPages.css";

const PrivacyPolicy = () => {
  const lastUpdated = "August 13, 2026";

  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Privacy Policy</h1>
        <p className="legal-updated">Last updated: {lastUpdated}</p>

        <p>
          Variant Exclusive ("we", "us", "our") operates variantexclusive.com
          (the "Site"). This Privacy Policy explains how we collect, use,
          disclose, and protect your information when you visit our Site or
          purchase our custom 3D-printed products.
        </p>

        <section>
          <h2>1. Information We Collect</h2>
          <h3>a) Information you provide to us</h3>
          <ul>
            <li>Name, email address, phone number</li>
            <li>Shipping and billing address</li>
            <li>Order details and customization preferences</li>
            <li>Account credentials, if you create an account</li>
            <li>Communications you send us (support requests, feedback)</li>
          </ul>

          <h3>b) Information collected automatically</h3>
          <ul>
            <li>IP address, browser type, and device information</li>
            <li>Pages visited, time spent, and referring URLs</li>
            <li>Cookies and similar tracking technologies</li>
          </ul>

          <h3>c) Payment information</h3>
          <p>
            Payments are processed securely through Cashfree Payments. We do
            not store your full card, UPI, or net-banking credentials on our
            servers — this data is handled directly by Cashfree in
            accordance with their own security standards and PCI-DSS
            compliance.
          </p>
        </section>

        <section>
          <h2>2. How We Use Your Information</h2>
          <ul>
            <li>To process and fulfil your orders, including custom 3D prints</li>
            <li>To communicate order status, shipping updates, and support responses</li>
            <li>To send order confirmations and, where opted in, promotional updates</li>
            <li>To improve our Site, products, and customer experience</li>
            <li>To detect and prevent fraud or unauthorized transactions</li>
            <li>To comply with legal obligations</li>
          </ul>
        </section>

        <section>
          <h2>3. Sharing of Information</h2>
          <p>We do not sell your personal information. We may share information with:</p>
          <ul>
            <li>Payment processors (Cashfree) to complete transactions</li>
            <li>Shipping and logistics partners to deliver your orders</li>
            <li>Service providers who help us operate the Site (hosting, analytics, email)</li>
            <li>Law enforcement or regulators, where legally required</li>
          </ul>
        </section>

        <section>
          <h2>4. Cookies</h2>
          <p>
            We use cookies to keep you signed in, remember your cart, and
            understand how visitors use our Site. You can control cookies
            through your browser settings; disabling them may affect some
            Site functionality.
          </p>
        </section>

        <section>
          <h2>5. Data Security</h2>
          <p>
            We use reasonable technical and organizational measures —
            including encrypted connections (HTTPS) — to protect your
            information. However, no method of transmission or storage is
            completely secure, and we cannot guarantee absolute security.
          </p>
        </section>

        <section>
          <h2>6. Data Retention</h2>
          <p>
            We retain your personal information for as long as necessary to
            fulfil the purposes described in this policy, comply with legal
            obligations (such as tax and accounting requirements), and
            resolve disputes.
          </p>
        </section>

        <section>
          <h2>7. Your Rights</h2>
          <p>You may contact us to:</p>
          <ul>
            <li>Access, correct, or update your personal information</li>
            <li>Request deletion of your account or personal data</li>
            <li>Opt out of marketing communications</li>
            <li>Ask questions about how your data is used</li>
          </ul>
        </section>

        <section>
          <h2>8. Children's Privacy</h2>
          <p>
            Our Site is not directed at children under 18. We do not
            knowingly collect personal information from children.
          </p>
        </section>

        <section>
          <h2>9. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Changes
            will be posted on this page with a revised "Last updated" date.
          </p>
        </section>

        <section>
          <h2>10. Contact Us</h2>
          <p>
            If you have questions about this Privacy Policy or how your data
            is handled, please contact us at{" "}
            <a href="mailto:variantexclusive@gmail.com">
              variantexclusive@gmail.com
            </a>.
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
